// import BPInput from 'components/BionicUI/input/BPInput';
import { FC, useEffect, useState } from 'react';
// import useOnboardingStore from 'stores/onboardingStore';
// import { checkIsEmailValid } from 'utils/validation';
import BPButton from '../../BionicUI/button/BPButton';
import BPContainer from '../../BionicUI/container/BPContainer';
import BPIcon from '../../BionicUI/icons/BPIcon';
import { OnboardingEye } from '../Eye';
import InputBar from '../InputBar';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { SequenceItem } from './OnboardingSequence';
// import { useAuth } from 'context/auth.context';
import { useNavigate } from 'react-router-dom';
import BPLinkButton from 'components/BionicUI/linkButton/BPLinkButton';
import { ROUTES } from 'routes';

const ChooseSignupMethod = () => {
  // const { signInWithGoogle } = useAuth();
  // const { setProgressStep } = useOnboardingStore();
  const [showInputBar, setShowInputBar] = useState<boolean>(false);

  // async function handleSignInWithGoogle() {
  //   try {
  //     await signInWithGoogle();
  //     setProgressStep(4);
  //   } catch (error) { }
  // }

  return (
    <SequenceItem>
      <div className="flex justify-center w-full max-w-[800px] px-6 gap-[20px] mx-auto items-start">
        <OnboardingEye />
        <ChooseSignupMethodInstruction
          setShowInputBar={setShowInputBar}
          delay={600}
        />
      </div>
      {showInputBar && (
        <></>
        // <EmailInputBar handleSignInWithGoogle={handleSignInWithGoogle} />
      )}
    </SequenceItem>
  );
};

export const EmailInputBar: FC<{
  handleSignIn: (method: ['email'] | ['google']) => {};
}> = ({ handleSignIn }) => {
  // const [showEmailInput, setShowEmailInput] = useState<boolean>(false);
  // const { setProgressStep, setEmail } = useOnboardingStore();
  const navigate = useNavigate();

  return (
    <>
      {/* {showEmailInput ? (
        <InputBar
          fadeUp
          showBackButton={false}
          key={'enter_your_email_address'}
        >
          <BPInput
            state="default"
            type="email"
            placeholder="Enter your email address"
            button={{
              state: 'primary',
              onClick: (e, inputText) => {
                setEmail(String(inputText));
                setProgressStep(2);
              },
              title: 'Submit',
            }}
            validate={(email) => checkIsEmailValid(email)}
          />
        </InputBar>
      ) : ( */}
      {/* <p className="text-base w-full">
        If you want to join as a project owner, then sign up with Google
      </p> */}
      <InputBar fadeUp showBackButton={false}>
        <BPContainer twWidth="w-auto md:w-[644px] justify-normal">
          <BPButton state="glass" onClick={() => handleSignIn(['email'])}>
            <BPIcon icon="mail" className="fill-white" /> Sign up with Email
          </BPButton>
          <BPButton state="glass" onClick={() => handleSignIn(['google'])}>
            <BPIcon icon="google" /> Sign up with Google
          </BPButton>
        </BPContainer>
        <BPLinkButton onClick={() => navigate(ROUTES.LOGIN)}>
          Already a member? Log in
        </BPLinkButton>
      </InputBar>
      {/* )}  */}
    </>
  );
};

export const ChooseSignupMethodInstruction: FC<{
  setShowInputBar: (show: boolean) => void;
  delay: number;
}> = ({ setShowInputBar, delay }) => {
  useEffect(() => {
    setTimeout(() => setShowInputBar(true), delay);
  }, [setShowInputBar]);

  return (
    <BPInstruction
      line1={{
        text: "Let's start your application. First, you'll need to create an account.",
        sound: 'step1/lets-start-your-application.mp3',
      }}
      line2={{
        text: 'Please enter an email address or sign up with Google...',
        sound: 'step1/please-enter-an-email.mp3',
      }}
    />
  );
};

export default ChooseSignupMethod;
